import { Link } from "@shopify/hydrogen";

export function UnderLineButton({ onClose, content, to }) {
  return (
    <Link
      onClick={onClose}
      to={to}
      className="cursor-pointer underline text-custom-blue"
    >
      {content}{" "}
    </Link>
  );
}
